import { render, staticRenderFns } from "./WorkTaskAuditTab.vue?vue&type=template&id=4ecd583e"
import script from "./WorkTaskAuditTab.vue?vue&type=script&lang=ts"
export * from "./WorkTaskAuditTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports